import { render, staticRenderFns } from "./appsPanelMenu.vue?vue&type=template&id=9d000704&"
import script from "./appsPanelMenu.vue?vue&type=script&lang=js&"
export * from "./appsPanelMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9d000704')) {
      api.createRecord('9d000704', component.options)
    } else {
      api.reload('9d000704', component.options)
    }
    module.hot.accept("./appsPanelMenu.vue?vue&type=template&id=9d000704&", function () {
      api.rerender('9d000704', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "common/components/appsPanelMenu.vue"
export default component.exports